import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { useEffect, useState, useRef } from "react";
import { getDropdownValues, getparentandultimateclientAttributes, getTimezoneDropdownList, getChannelDropdownList } from "../newClientRequest/dropdownService";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import Spinner from "../../components/shared/spinner.jsx";
import { hideLoader } from "../../datasource/msal";
import { EDITPROGRAMPROJECT_URL, PROGRAMPROJECTREQUESTLIST_URL, ValidateProgramProject_URL } from "../../constants";
import axios from "../../datasource/axios";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { hasDisallowedNameCharacters, buildDisallowedNameCharsMessage } from "../../utils/nameValidation";

interface Item {
  name: string;
  code: number;
}

export const EditProgramProject = (props: any) => {
  const BASE_URL = process.env.REACT_APP_API_URI as string;
  const [selectedItem, setSelectedItem] = useState<Item | null>(null);
  const [clients, setClients] = useState<Item[]>([{ 'name': '', 'code': 0 }]);
  const client: Item[] = clients.map((client, i) => ({ name: `${client.name} - ${client.code}`, code: client.code }));
  const [selectedPrograms, setSelectedPrograms] = useState<Item | null>(null);
  const [programs, setPrograms] = useState<Item[]>([{ 'name': '', 'code': 0 }]);
  const [selectedSupportGrp, setSelectedSupportGrp] = useState({ "code": "", "name": "" });
  const [selectedManagedBy, setSelectedManagedBy] = useState('');
  const [selectedOpsvp, setSelectedOpsvp] = useState('');
  const [supportgroups, setSupportGroups] = useState([]);
  const [selectedProject, setselectedProject] = useState('');
  const [showLoader, setShowLoader] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState('');
  const projectRef = useRef<any>();
  const programRef = useRef<any>();
  const toast = useRef<any>(null);
  const managedbyRef = useRef<any>();
  const opsvpRef = useRef<any>();
  const [visible, setVisible] = useState(false);
  const [timezones, setTimezones] = useState([]);
  const [timezoneval, setTimezoneVal] = useState({ "code": "", "name": "" });
  const [channelTypes, setChannelTypes] = useState<any[]>([]);
  const [channelval, setChannelVal] = useState<any[]>([]);
  const [channelDropdownOpen, setChannelDropdownOpen] = useState(false);
  const channelDropdownRef = useRef<any>(null);

  const getdropdowndata = async () => {
    let clientResponse: any =
      await getparentandultimateclientAttributes("c"); // to get existing clients
    let codes = clientResponse?.codes;
    setClients(codes);
  }

  const populateForm = () => {
    const lastIndexClient = props?.details?.client.lastIndexOf('-');
    const lastIndexProgram = props?.details?.program.lastIndexOf('-');
    getdropdowndata();
    getsupportgroups();
    gettimezone();
    getchanneltypes();
    handleclientchange({ "name": props?.details?.client, "code": lastIndexClient === -1 ? props?.details?.client : props?.details?.client.substring(lastIndexClient + 1).trim() });
    setShowLoader(true);
    setSelectedItem({ "name": props?.details?.client, "code": lastIndexClient === -1 ? props?.details?.client : props?.details?.client.substring(lastIndexClient + 1).trim() });
    if (!props?.details?.isNewProgram) {
      setSelectedPrograms({ "name": props?.details?.program.substring(0, lastIndexProgram).trim(), "code": lastIndexProgram === -1 ? props?.details?.program : props?.details?.program.substring(lastIndexProgram + 1).trim() });
    }
    else {
      setSelectedProgram(props?.details?.program);
    }
    setselectedProject(props?.details?.project);
    setSelectedManagedBy(props?.details?.managedBy);
    setSelectedOpsvp(props?.details?.opsVP);
    //setShowLoader(false);
  }

  useEffect(() => {
    populateForm();
  }, []);

  useEffect(() => {
    if (channelTypes && channelTypes.length > 0) {
      if (props?.details?.channelTypeId) {
        const ids = props?.details?.channelTypeId.toString().split("|").map((s: string) => s.trim());
        const matched = channelTypes.filter((c: any) => ids.includes(c.code.toString()));
        setChannelVal(matched.length > 0 ? matched : []);
      } else {
        const defaultChannel = channelTypes.find((c: any) => c.code === "1");
        if (defaultChannel) setChannelVal([defaultChannel]);
      }
    }
  }, [channelTypes]);

  useEffect(() => {
    if (clients.length > 1) {
      setShowLoader(false);
    }
  }, [clients])

  useEffect(() => {
    const id = getCode(props?.details?.supportGroupName, supportgroups);
    setSelectedSupportGrp({ "code": id, "name": props?.details?.supportGroupName });
  }, [supportgroups]);

  useEffect(() => {
    setTimezoneVal({ "code": props?.details?.timeZoneId, "name": props?.details?.timeZoneName });
  }, [timezones]);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (channelDropdownRef.current && !channelDropdownRef.current.contains(e.target)) {
        setChannelDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleclientchange = (value: any) => {
    setSelectedItem(value);
    getdropdowndataprogram("pr", value.code.toString());
  }

  const handleprogramchange = (value: any) => {
    setSelectedPrograms(value);
  }

  const programTemplate = (option: any) => {
    return (
      <div className="flex align-items-center">
        <div>{option.name} - {option.code}</div>
      </div>
    );
  };

  const selectedProgramTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <div>{option.name} - {option.code}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const getdropdowndataprogram = async (type: string, code: string) => {
    setShowLoader(true);
    let clientResponse: any =
      await getparentandultimateclientAttributes(type, code); // to get existing clients
    let codes = clientResponse?.codes;
    setPrograms(codes);
    setShowLoader(false);
  }

  const getsupportgroups = async () => {
    let supgrpResponse: any = await getDropdownValues("asknow_support_groups");
    let codes = supgrpResponse?.codes;
    setSupportGroups(codes);
  }

  const getchanneltypes = async () => {
    let channelresponse: any = await getChannelDropdownList();
    let codes = channelresponse?.channeltypes;
    setChannelTypes(codes);
  }

  const handlesuppotgrpchange = (val: any) => {
    setSelectedSupportGrp(val);
  }

  const gettimezone = async () => {
    let timezoneresponse: any = await getTimezoneDropdownList();
    let codes = timezoneresponse?.timezones;
    setTimezones(codes);
  }

  const validateProgramProject = async (name: any, type: any, id: any) => {
    let url = BASE_URL + ValidateProgramProject_URL;
    const res: any = await new Promise((resolve, reject) => {
      try {
        setShowLoader(true);
        axios
          .getRequest(url + "?name=" + name + "&type=" + type + "&code=" + id + '&id=' + props?.details?.id)
          .then((res: any) => {
            setShowLoader(false);
            hideLoader();
            resolve(res);
          })
          .catch((err: any) => {
            setShowLoader(false);
            hideLoader();
            resolve(err);
          });
      } catch (error) {
        setShowLoader(false);
        hideLoader();
        reject(error);
      }
    });

    if (res.statusCode === 200 && res.isValid) {
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Valid " + (type === 'program' ? "Program" : "Project") + " Name",
        life: 3000,
      });
    } else if (res.statusCode === 200 && !res.isValid) {
      if (type === 'program') {
        programRef.current.focus();
      }
      else if (type === 'project') {
        projectRef.current.focus();
      }

      toast.current.show({
        severity: "warn",
        summary: "Warn",
        detail: (type === 'program' ? "Program" : "Project") + " Name already exists",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error checking for valid " + (type === 'program' ? "Program" : "Project") + " Name",
        life: 3000,
      });
    }
  };

  const onprogramblur = (e: any) => {
    if (hasDisallowedNameCharacters(e.target.value)) {
      programRef.current.focus();
      toast.current.show({ severity: "warn", summary: "Warn", detail: buildDisallowedNameCharsMessage(e.target.value), life: 3000 });
      return;
    }
    validateProgramProject(
      e.target.value,
      'program',
      selectedItem?.code
    );
  }

  const onprojectblur = (e: any) => {
    if (hasDisallowedNameCharacters(e.target.value)) {
      projectRef.current.focus();
      toast.current.show({ severity: "warn", summary: "Warn", detail: buildDisallowedNameCharsMessage(e.target.value), life: 3000 });
      return;
    }
    validateProgramProject(
      e.target.value,
      'project',
      props?.details?.isNewProgram ? selectedProgram : selectedPrograms?.code
    );
  }

  const onmanagedbyblur = (e: any) => {
    if (e.target.value !== null && e.target.value !== "" && e.target.value !== undefined) {
      if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i.test(e.target.value)) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Valid Email Address",
          life: 3000,
        });
      }
      else {
        managedbyRef.current.focus();
        toast.current.show({
          severity: "warn",
          summary: "Warn",
          detail: "Please Enter Valid Email Address",
          life: 3000,
        });
      }
    }
  }

  const onopsvpblur = (e: any) => {
    if (e.target.value !== null && e.target.value !== "" && e.target.value !== undefined) {
      if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i.test(e.target.value)) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Valid Email Address",
          life: 3000,
        });
      }
      else {
        opsvpRef.current.focus();
        toast.current.show({
          severity: "warn",
          summary: "Warn",
          detail: "Please Enter Valid Email Address",
          life: 3000,
        });
      }
    }
  }


  const editProgramProject = async (isSubmitted: boolean) => {
    if (selectedItem === null || (!props?.details?.isNewProgram && selectedPrograms === null) || (props?.details?.isNewProgram && selectedProgram === null) || selectedProject === ''
      || selectedManagedBy === '' || selectedSupportGrp.name === '' || selectedOpsvp === '' || !(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i.test(selectedManagedBy)) || !(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i.test(selectedOpsvp))) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Please Enter all Manatory Fields and Valid Email Addresses",
        life: 3000
      });
      return;
    }

    setShowLoader(true);

    var request = {
      id: props?.details?.id,
      client: selectedItem?.code,
      clientname: props?.details?.client,
      program: props?.details?.isNewProgram ? selectedProgram : selectedPrograms?.code,
      programname: props?.details?.program,
      project: selectedProject,
      managedby: selectedManagedBy,
      supportgroup: selectedSupportGrp.name,
      opsvp: selectedOpsvp,
      issubmitted: isSubmitted,
      isnewprogram: props?.details?.isNewProgram,
      timezoneid: timezoneval.code,
      timezonename: timezoneval.name,
      channeltypeid: channelval.map((c: any) => c.code).join("|"),
      channeltypename: channelval.map((c: any) => c.name).join("|")
    };

    let BASE_URL = process.env.REACT_APP_API_URI;
    let url = BASE_URL + EDITPROGRAMPROJECT_URL;

    const res: any = await new Promise((resolve, reject) => {
      try {
        axios
          .postRequest(url, request)
          .then((res: any) => {
            setShowLoader(false);
            resolve(res);
          })
          .catch((err: any) => {
            setShowLoader(false);
            resolve(err);
          });
      } catch (error) {
        setShowLoader(false);
        reject(error);
      }
    });

    if (res.status == "Success") {
      setVisible(true);
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Record Update Failed",
        life: 8000,
      });
    }
    setShowLoader(false);
  }

  const getCode = (name: string, collection: any) => {
    var codeIdx = -1;
    for (var i = 0; i < collection.length; i++) {

      if (collection[i].name === name) {
        codeIdx = collection[i].code;
        if (codeIdx === undefined) {
          codeIdx = collection[i].id;
        }
        break;
      }
    }
    return codeIdx.toString();
  };


  const handlesave = () => {
    setVisible(false);
    props?.handleCallback(false);
    fetchDashboard();
  }

  const footerContent = (
    <div>
      <Button label="Ok" icon="pi pi-check" style={{ backgroundColor: "#3299FF", color: "white" }} onClick={handlesave} autoFocus />
    </div>
  );

  const getCppRequestListByUserid = () => {
    let BASE_URL = process.env.REACT_APP_API_URI;
    let url = BASE_URL + PROGRAMPROJECTREQUESTLIST_URL;

    return new Promise((resolve, reject) => {
      try {
        axios.getRequest(url)
          .then((res: any) => {
            hideLoader();
            resolve(res);
          })
          .catch((err: any) => {
            resolve(err);
          });
      } catch (error: any) {
        reject(error);
      }
    });
  };

  const fetchDashboard = async () => {
    const response: any = await getCppRequestListByUserid();
    props.handleDataCallback(response);
  }


  return (
    <>
      <div>
        <Toast ref={toast} />
        <div className="row">
          <div className="col-md-10">
            <div className="m-2">
              <span className="selectList">
                <label
                  htmlFor="client"
                >
                  Client*
                </label>
                <Dropdown
                  id="client"
                  name="client"
                  filter
                  placeholder="Select a Client"
                  value={selectedItem}
                  virtualScrollerOptions={{ itemSize: 30 }}
                  onChange={(e: DropdownChangeEvent) => handleclientchange(e.value)}
                  options={client}
                  optionLabel="name"
                  style={{ width: "100%" }}
                  disabled={true}
                />
              </span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-10">
            <div className="m-2">
              {!props?.details?.isNewProgram &&
                <span className="selectList">
                  <label
                    htmlFor="program"
                  >
                    Program*
                  </label>
                  <Dropdown
                    id="program"
                    name="program"
                    filter
                    placeholder="Select a Program"
                    value={selectedPrograms}
                    onChange={(e: DropdownChangeEvent) => handleprogramchange(e.value)}
                    options={programs}
                    itemTemplate={programTemplate}
                    valueTemplate={selectedProgramTemplate}
                    optionLabel="name"
                    style={{ width: "100%" }}
                    disabled={true}
                  />
                </span>
              }
              {props?.details?.isNewProgram &&
                <span>
                  <label
                    htmlFor="program"
                  >
                    Program*
                  </label>
                  <div style={{ display: 'flex' }}>
                    <InputText
                      id="program"
                      name="program"
                      type="text"
                      // maxLength={4}
                      placeholder="Enter Program Name"
                      value={selectedProgram || ''}
                      onChange={(e) => setSelectedProgram(e.target.value)}
                      style={{ width: "100%" }}
                      onBlur={(e: any) => onprogramblur(e)}
                      ref={programRef}
                      disabled={props.mode === "view" ? true : false}
                    />
                  </div>
                </span>
              }
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-10">
            <div className="m-2">
              <label
                htmlFor="project"
              >
                Project*
              </label>
              <div style={{ display: 'flex' }}>
                <InputText
                  id="project"
                  name="project"
                  type="text"
                  // maxLength={4}
                  placeholder="Enter Project Name"
                  value={selectedProject || ''}
                  onChange={(e) => setselectedProject(e.target.value)}
                  style={{ width: "100%" }}
                  onBlur={(e: any) => onprojectblur(e)}
                  ref={projectRef}
                  disabled={props.mode === "view" ? true : false}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-10">
            <div className="m-2">
              <label
                htmlFor="managedby"
              >
                Managed By*
              </label>
              <div style={{ display: 'flex' }}>
                <InputText
                  id="managedby"
                  name="managedby"
                  type="text"
                  // maxLength={4}
                  placeholder="Enter Managed By"
                  value={selectedManagedBy || ''}
                  onChange={(e) => setSelectedManagedBy(e.target.value)}
                  style={{ width: "100%" }}
                  onBlur={(e: any) => onmanagedbyblur(e)}
                  ref={managedbyRef}
                  disabled={props.mode === "view" ? true : false}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-10">
            <div className="m-2">
              <span className="selectList">
                <label
                  htmlFor="supportGroups"
                >
                  Support Group*
                </label>
                <Dropdown
                  id="supportGroups"
                  name="supportGroups"
                  filter
                  onChange={(e: any) => handlesuppotgrpchange(e.target.value)}
                  value={selectedSupportGrp}
                  //  disabled={props.mode === "View" ? true : false}
                  options={supportgroups}
                  optionLabel="name"
                  style={{ width: "100%" }}
                  disabled={props.mode === "view" ? true : false}
                />
              </span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-10">
            <div className="m-2">
              <label
                htmlFor="opsvp"
              >
                Ops VP*
              </label>
              <div style={{ display: 'flex' }}>
                <InputText
                  id="opsvp"
                  name="opsvp"
                  type="text"
                  // maxLength={4}
                  placeholder="Enter Opsvp"
                  value={selectedOpsvp || ''}
                  onChange={(e) => setSelectedOpsvp(e.target.value)}
                  style={{ width: "100%" }}
                  onBlur={(e: any) => onopsvpblur(e)}
                  ref={opsvpRef}
                  disabled={props.mode === "view" ? true : false}
                />
              </div>
            </div>
          </div>
        </div>
        {props?.details?.isNewProgram &&
          <div className="row">
            <div className="col-md-10">
              <div className="m-2">
                <span className="selectList">
                  <label id="lbl"
                    htmlFor="timezone"
                  >
                    Timezone*
                  </label>
                  <Dropdown
                    id="timezone"
                    name="timezone"
                    filter
                    value={timezoneval}
                    disabled={props.mode === "view" ? true : false}
                    options={timezones}
                    onChange={(e) => setTimezoneVal(e.target.value)}
                    optionLabel="name"
                    style={{ width: "100%" }}
                  />
                </span>
              </div>
            </div>
          </div>}
        <div className="row">
          <div className="col-md-10">
            <div className="m-2">
              <label id="lbl" htmlFor="channeltype">Channel</label>
              <div ref={channelDropdownRef} style={{ position: "relative", width: "100%" }}>
                <div
                  onClick={() => setChannelDropdownOpen(!channelDropdownOpen)}
                  style={{
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    padding: "8px 12px",
                    cursor: "pointer",
                    background: "#fff",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    minHeight: "42px",
                    width: "100%"
                  }}
                >
                  <span style={{ fontSize: "14px", color: channelval.length === 0 ? "#aaa" : "#000" }}>
                    {channelval.length === 0
                      ? "Select Channel(s)"
                      : channelval.length <= 2
                        ? channelval.map((c: any) => c.name).join(", ")
                        : `${channelval.length} channels selected`}
                  </span>
                  <i className="pi pi-chevron-down" style={{ fontSize: "12px", color: "#666" }} />
                </div>
                {channelDropdownOpen && (
                  <div style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    background: "#fff",
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    zIndex: 9999,
                    maxHeight: "200px",
                    overflowY: "auto",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                  }}>
                    {channelTypes.map((channel: any) => {
                      const selected = channelval.some((c: any) => c.code === channel.code);
                      return (
                        <div
                          key={channel.code}
                          onClick={() => {
                            if (props.mode === "view") return; // block changes in view mode
                            const updated = selected
                              ? channelval.filter((c: any) => c.code !== channel.code)
                              : [...channelval, channel];
                            setChannelVal(updated);
                          }}
                          style={{
                            padding: "8px 12px",
                            cursor: props.mode === "view" ? "default" : "pointer",
                            background: selected ? "#e8f4ff" : "#fff",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            fontSize: "14px",
                            borderBottom: "1px solid #f0f0f0"
                          }}
                        >
                          <input
                            type="checkbox"
                            readOnly
                            checked={selected}
                            style={{ cursor: props.mode === "view" ? "default" : "pointer", accentColor: "#3299FF" }}
                          />
                          {channel.name}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="m-5">
        </div>
      </div>
      {props?.mode === "edit" && (
        <div style={{ position: 'absolute', bottom: 0, right: 0, padding: '10px', backgroundColor: 'aliceblue', width: '-webkit-fill-available' }}>
          <Button
            onClick={() => editProgramProject(false)}
            type="button"
            label="Save as Draft"
            className="btnNext"
            size="large"
            style={{ float: 'right' }}
          />
          <Button
            onClick={() => editProgramProject(true)}
            type="submit"
            label="Submit"
            className="btnNext"
            size="large"
            style={{ float: 'right' }}
          />
        </div>)}
      <div>
        {showLoader && (
          <div className="divSpinner3">
            <Spinner />
          </div>
        )}
      </div>
      <Dialog visible={visible} modal footer={footerContent} onHide={() => { if (!visible) return; setVisible(false); }} closable={false} style={{ width: '30rem' }}>
        <p className="m-0">
          Record Updated Successfully.
        </p>
      </Dialog>
    </>);
}